import dynamic from 'next/dynamic'

export const HeroV2 = dynamic(() => import('./hero-v2'))
